// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `body{
    background-color:"#273142 !important"; 
}
.logdes{
    background-color: #273142 !important;
    margin-top: 0px !important;
}
.accsign{
    color: #fff !important;
}`, "",{"version":3,"sources":["webpack://./src/components/Signin.css"],"names":[],"mappings":"AAAA;IACI,qCAAqC;AACzC;AACA;IACI,oCAAoC;IACpC,0BAA0B;AAC9B;AACA;IACI,sBAAsB;AAC1B","sourcesContent":["body{\n    background-color:\"#273142 !important\"; \n}\n.logdes{\n    background-color: #273142 !important;\n    margin-top: 0px !important;\n}\n.accsign{\n    color: #fff !important;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
